import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetCloseOpenCourtBySearch(club, url) {

  var url = "/reservation/get_open_close_by_search/" + club + url; 

  return FetchGetDataWithAuthNEW(url);
}

